import { useEffect } from "react";
import { useRouteMatch } from "react-router";

import { HOME_URL } from "../../routes/HomePage/HomePage";

import { SUBNAV } from "./types";
import { URL } from "../../constants/navigation";
import { useHeaderContext } from "../Header/context";

export const useRouteSelectedHandler = (setSubNav: React.Dispatch<React.SetStateAction<SUBNAV | undefined>>) => {
  const { isNavOpen } = useHeaderContext();
  const homeMatch = useRouteMatch(HOME_URL);
  const usersMatch = useRouteMatch(URL.USERS);
  const settingsMatch = useRouteMatch(URL.SETTINGS);
  const reportsMatch = useRouteMatch(URL.REPORTS);
  const superAdminMatch = useRouteMatch(URL.SUPER_ADMIN);

  const isHomePage = Boolean(homeMatch?.isExact);
  const isUsersPage = Boolean(usersMatch);
  const isSettingsPage = Boolean(settingsMatch);
  const isReportsPage = Boolean(reportsMatch);
  const isSuperAdminPage = Boolean(superAdminMatch);

  useEffect(() => {
    if (!isUsersPage || !isNavOpen) return;
    setSubNav(SUBNAV.USERS);
  }, [isNavOpen, isUsersPage]);

  useEffect(() => {
    if (!isSettingsPage || !isNavOpen) return;
    setSubNav(SUBNAV.SETTINGS);
  }, [isNavOpen, isSettingsPage]);

  useEffect(() => {
    if (!isReportsPage || !isNavOpen) return;
    setSubNav(SUBNAV.REPORTS);
  }, [isNavOpen, isReportsPage]);

  useEffect(() => {
    if (!isSuperAdminPage || !isNavOpen) return;
    setSubNav(SUBNAV.SUPER_ADMIN);
  }, [isNavOpen, isSuperAdminPage]);

  return {
    isHomePage,
  };
};
